import { createFileRoute } from "@tanstack/react-router";
import NegotiationsPage from "@/components/negotiations/negotiations-page";

function BrokerReceivedNegotiationsPage() {
  return <NegotiationsPage viewMode="shipper" />;
}

export const Route = createFileRoute("/_app/negotiations/received")({
  component: BrokerReceivedNegotiationsPage,
});
